/**
 * Business toggle for the sales agent (Account Manager) name + phone on web
 * appointment surfaces: listing card, status card / sheet, confirmed dialog.
 * When false, every surface renders its existing "no agent" layout.
 */
export const SHOW_SALES_AGENT_CONTACT = false;
